import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { isObject } from 'lodash';
import { useProductListingState } from '../RangePlanProductListingProvider';
import noImage from '../../../../assets/images/no-image.png';
import { shortenandHoverString } from '../../../../Components/helper';
import CommonImageComponent from '../../../../Components/Utility/CommonImage';
import Loader from '../../../../Components/Utility/Loader/Loader';

const STATIC_COLUMN_COUNT = 24;

export default function ProductBOM(props) {
  const { handlePageNextInScroll, loadNextData, handleSelection, selectedIds, isSelectAll } = props;
  const { t } = useTranslation('common');
  const dateFormat = 'DD-MMM-YYYY';
  const {
    rangePlanProvider: { productsNumber, productsList, bomCustomAttributeColumns },
  } = useProductListingState();
  const customAttributeColumns = bomCustomAttributeColumns || [];

  const [expandedRowIndex, setExpandedRowIndex] = useState([]);
  const [isExpandAll, setIsExpandAll] = useState(false);

  useEffect(() => {
    if (isExpandAll && productsList?.length > 0) {
      setExpandedRowIndex(productsList.map((_, index) => index));
    }
  }, [productsList?.length]);

  const getValue = (value) => {
    if (isObject(value)) {
      return value?.name || '';
    }
    return value || '--';
  };

  const expandMoreData = (index) => {
    if (expandedRowIndex.includes(index)) {
      setIsExpandAll(false);
      setExpandedRowIndex(expandedRowIndex.filter((item) => item !== index));
    } else {
      setExpandedRowIndex([...expandedRowIndex, index]);
    }
  };

  const expandAllProdIdentifier = () => {
    if (isExpandAll) {
      setIsExpandAll(false);
      setExpandedRowIndex([]);
    } else {
      setIsExpandAll(true);
      setExpandedRowIndex(productsList?.map((_, index) => index) || []);
    }
  };

  const renderStatus = (rowDetails) => {
    const status = rowDetails?.[0]?.status;
    const commentDate = rowDetails?.[0]?.commentDate;
    const commentBy = `${rowDetails?.[0]?.approveBy?.name}`;
    const a = moment(rowDetails?.[0]?.commentDate);
    const b = moment();
    const bomDateCount = a.diff(b, 'days');
    return (
      <>
        <p className="mb-0 f-16">
          {status === 1 ? t('COMMON_LABEL.APPROVED') : t('COMMON_LABEL.REJECTED')}/{moment(commentDate).format(dateFormat)}
        </p>
        <p className="mb-0 f-16">
          ({bomDateCount}) ({commentBy})
        </p>
      </>
    );
  };

  const getComponentSupplier = (rowDetails) => {
    if (rowDetails?.combinationSuppliers?.length > 0) {
      return <p>Multiple</p>;
    }
    if (rowDetails?.BOMSupplier && rowDetails?.BOMSupplier[0]?.companies && rowDetails?.BOMSupplier[0]?.companies[0]?.supplierName) {
      return rowDetails?.BOMSupplier[0]?.companies[0].supplierName;
    }
    return (rowDetails?.BOMSupplier && rowDetails?.BOMSupplier[0]?.firstName) || '--';
  };
  return (
    <div id="ProductIdentifierRPTableContainer" className="rp-scroll-container">
      <InfiniteScroll
        dataLength={productsList?.length}
        hasMore={productsList?.length < productsNumber}
        next={handlePageNextInScroll}
        loader={loadNextData && <Loader />}
        className="fixed-col-container rp-table-container"
        scrollableTarget="ProductIdentifierRPTableContainer"
      >
        <table id="RPProductBOMTable" className="table common-custom-table fixed-header mb-0">
          <thead>
            <tr>
              <th aria-label="checkbox" className="w-50px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelection(e.target.checked)}
                    name="check_all_product_bom"
                    id="check_all_product_bom"
                    checked={isSelectAll}
                    disabled={!productsList?.length}
                  />
                  <label htmlFor="check_all_product_bom" className="chklabel" />
                </div>
              </th>
              <th className="w-50px">
                <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandAllProdIdentifier()}>
                  {isExpandAll ? <span className="icon-new-down-arrow-icon icon-inverse" /> : <span className="icon-new-down-arrow-icon " />}
                </button>
              </th>
              <th className="w-80px">{t('RANGE_PLANS.PRODUCT_LIST.IMAGE')}</th>
              <th className="w-220px">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER')}</th>
              <th className="w-150px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.CODE')}</th>
              <th className="w-150px first-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.BOM_TYPE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.DESCRIPTION')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COMPONENT_TYPE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COMPONENT_SUB_TYPE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COMPONENT_SUPPLIER')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.WEIGHT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.PRICE_PER_UNIT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.SIZE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.QUANTITY')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COMPOSITION')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.PLACEMENT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.FINISH')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.ADDITIONAL_INFORMATION')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COLOURWAY')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COLOR_ARTWORK')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COLOR_ARTWORK_REF')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.SKU_NUMBER')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.COLOR_PLACEMENT')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.NO_OF_DOC')}</th>
              {customAttributeColumns.map((col) => (
                <th key={col?._id} className="w-224px">
                  {col?.header}
                </th>
              ))}
              <th className="w-200px last-fix-col">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_BOM_TABLE.QUALITY_STATUS')}</th>
            </tr>
          </thead>

          {productsList?.length > 0 ? (
            productsList?.map((ele, productIndex) => {
              const initialData = ele?.initialData;

              const productImage = ele?.image || noImage;
              return (
                <tbody key={ele?._id}>
                  <tr>
                    <td>
                      <div className="common-checkbox margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(ele?._id);
                          }}
                          name={`checks_${productIndex}`}
                          id={`checks_${productIndex}`}
                          type="checkbox"
                          checked={selectedIds?.filter((val) => val === ele?._id)?.length > 0}
                        />
                        <label htmlFor={`checks_${productIndex}`} className="chklabel" />
                      </div>
                    </td>
                    <td>
                      {ele?.expandData?.length > 0 && (
                        <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandMoreData(productIndex)}>
                          {expandedRowIndex.includes(productIndex) ? (
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          ) : (
                            <span className="icon-new-down-arrow-icon" />
                          )}
                        </button>
                      )}
                    </td>
                    <td>
                      <CommonImageComponent productImage={productImage} />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(ele?.number || '--', 20)}
                        <button type="button" className="btn ml-auto" aria-label="info">
                          <OverlayTrigger
                            placement={t('TAKING_DATES.BUTTON')}
                            trigger="hover"
                            rootClose
                            overlay={
                              <Popover className="custom-popover">
                                <Popover.Content>
                                  <p className="mb-8">
                                    <b className="text-bold">Product Type: </b>
                                    {getValue(ele?.supplierType)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Description: </b>
                                    {getValue(ele?.description)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Brand: </b>
                                    {getValue(ele?.brandId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Season: </b>
                                    {getValue(ele?.seasonId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Month: </b>
                                    {getValue(ele?.month)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Year: </b>
                                    {getValue(ele?.year)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Colourway(s): </b>

                                    {ele?.colourLibraries?.map((gradEle) => gradEle?.name).join(', ') || '--'}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Size: </b>
                                    {ele?.sizeRanges?.join(', ') || '--'}
                                  </p>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <span className="icon icon-Information f-20" />
                          </OverlayTrigger>
                        </button>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(initialData?.referenceCode || '--', 12)}
                        {ele?.expandData?.length > 0 && (
                          <Link target="_blank" to={`/development-order/${ele?._id}/bom`} className="px-3 ml-auto text-decoration-none">
                            <span className="icon-redirect f-20" />
                          </Link>
                        )}
                        <div style={{ width: 20 }}>
                          {ele?.expandData?.length > 0 && <Badge className="range-badge badge badge-rp-counter">{(ele?.expandData?.length || 0) + 1}</Badge>}
                        </div>
                      </div>
                    </td>
                    <td className="first-fix-col">{initialData?.bomType?.name || '--'}</td>
                    <td>{shortenandHoverString(initialData?.bomDescription || '--', 40)}</td>
                    <td>{initialData?.bomSubType?.name || '--'}</td>
                    <td>{initialData?.bomComponentSubType?.name || '--'}</td>
                    <td>{getComponentSupplier(initialData)}</td>
                    <td>
                      {initialData?.weight || '--'} {initialData?.weightUnitOfMeasure?.name}
                    </td>
                    <td>
                      {initialData?.pricePerUnit || '--'} {initialData?.pricePerUnitCurrency || '--'}
                    </td>
                    <td>
                      {initialData?.size || '--'} {initialData?.sizeUnitOfMeasure?.name}
                    </td>
                    <td>
                      {initialData?.quantity || '--'} {initialData?.quantityUnitOfMeasure?.name}
                    </td>
                    <td>{initialData?.composition?.map((comp) => `${comp?.percentage ?? 0}% ${comp?.composition?.name ?? ''}`)?.join(', ') || '--'}</td>
                    <td>{initialData?.newPlacement?.map((item) => item?.name)?.join(', ') || '--'}</td>
                    <td>{initialData?.finished?.name || '--'}</td>
                    <td>{shortenandHoverString(initialData?.additionalInfo || '--', 40)}</td>
                    <td>{initialData?.colourWay?.colourWayId?.name || '--'}</td>
                    <td>{initialData?.colourWayRef?.colourRef?.name || '--'}</td>
                    <td>{initialData?.colourWayRef?.colourRefName?.name || '--'}</td>
                    <td>{initialData?.skuNumbers || '--'}</td>
                    <td>{initialData?.colourWayRef?.colourPlacement?.name || '--'}</td>
                    <td>{initialData?.totalDocs || 0}</td>
                    {customAttributeColumns.map((col) => (
                      <td key={col?._id}>{shortenandHoverString(initialData?.bomCustomAttributes?.[col?._id] || '--', 20)}</td>
                    ))}
                    <td className="last-fix-col">
                      {initialData?.bomApprovals?.length > 0 ? renderStatus(initialData?.bomApprovals) : t('COMMON_LABEL.PENDING')}
                    </td>
                  </tr>
                  {expandedRowIndex.includes(productIndex) &&
                    ele?.expandData?.map((expData) => {
                      return (
                        <tr className="expand-row" key={expData?._id}>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td> {shortenandHoverString(expData?.referenceCode || '--', 12)}</td>
                          <td className="first-fix-col">{expData?.bomType?.name}</td>
                          <td>{shortenandHoverString(expData?.bomDescription || '--', 40)}</td>
                          <td>{expData?.bomSubType?.name}</td>
                          <td>{expData?.bomComponentSubType?.name || '--'}</td>
                          <td>{getComponentSupplier(expData)}</td>
                          <td>
                            {expData?.weight || '--'} {expData?.weightUnitOfMeasure?.name}
                          </td>
                          <td>
                            {expData?.pricePerUnit || '--'} {expData?.pricePerUnitCurrency || '--'}
                          </td>
                          <td>
                            {expData?.size || '--'} {expData?.sizeUnitOfMeasure?.name}
                          </td>
                          <td>
                            {expData?.quantity || '--'} {expData?.quantityUnitOfMeasure?.name}
                          </td>
                          <td>{expData?.composition?.map((comp) => `${comp?.percentage ?? 0}% ${comp?.composition?.name ?? ''}`)?.join(', ') || '--'}</td>
                          <td>{expData?.newPlacement?.map((item) => item?.name)?.join(', ') || '--'}</td>
                          <td>{expData?.finished?.name || '--'}</td>
                          <td>{shortenandHoverString(expData?.additionalInfo || '--', 40)}</td>
                          <td>{expData?.colourWay?.colourWayId?.name || '--'}</td>
                          <td>{expData?.colourWayRef?.colourRef?.name || '--'}</td>
                          <td>{expData?.colourWayRef?.colourRefName?.newReferences || '--'}</td>
                          <td>{expData?.skuNumbers || '--'}</td>
                          <td>{expData?.colourWayRef?.colourPlacement?.name || '--'}</td>
                          <td>{expData?.totalDocs || 0}</td>
                          {customAttributeColumns.map((col) => (
                            <td key={col?._id}>{shortenandHoverString(expData?.bomCustomAttributes?.[col?._id] || '--', 20)}</td>
                          ))}
                          <td className="last-fix-col">
                            {expData?.bomApprovals?.length > 0 ? renderStatus(expData?.bomApprovals) : t('COMMON_LABEL.PENDING')}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              );
            })
          ) : (
            <tr>
              <td colSpan={STATIC_COLUMN_COUNT + customAttributeColumns.length} className="text-center">
                {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORDS_FOUND')}
              </td>
            </tr>
          )}
        </table>
      </InfiniteScroll>
    </div>
  );
}
